// extracted by mini-css-extract-plugin
export default {"logoutBtn":"NavbarHeader_logoutBtn__W2Pr3"};